(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rq-buy-area"] && !Shopify.designMode) return;
  try {
    /* When the offers app loads with no offer selected, select the first (single item) offer once, so the colour
     choice inside it shows straight away. A choice the shopper makes is never changed. */
  (function () {
    if (window.rqOfferDefaultStarted) return;
    window.rqOfferDefaultStarted = true;
    var done = false;
    function trySelect() {
      if (done) return true;
      var widget = document.querySelector('.product-information smart-widget');
      if (!widget) return false;
      var offers = widget.querySelectorAll('.sw-offer');
      if (!offers.length) return false;
      done = true;
      if (!widget.querySelector('.sw-offer--selected')) offers[0].click();
      return true;
    }
    function start() {
      if (trySelect()) return;
      var observer = new MutationObserver(function () { if (trySelect()) observer.disconnect(); });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rq-motion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.rqMotionStarted) return;
    window.rqMotionStarted = true;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!window.matchMedia) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) return;

    var CDN = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/';

    function load(src) {
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function isRqSection(el) {
      for (var i = 0; i < el.classList.length; i++) {
        if (el.classList[i].indexOf('rq-') === 0) return true;
      }
      return false;
    }

    function belowScreen(el) {
      return el.getBoundingClientRect().top > window.innerHeight;
    }

    /* React Bits "BlurText" idea without React or blur: wrap plain-text headings word by word. */
    function splitWords(heading) {
      if (!heading || heading.dataset.rqSplit || heading.children.length) return [];
      var text = heading.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return [];
      heading.setAttribute('aria-label', text);
      heading.textContent = '';
      var words = [];
      text.split(' ').forEach(function (word, i) {
        if (i) heading.appendChild(document.createTextNode(' '));
        var span = document.createElement('span');
        span.className = 'rq-word';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = word;
        heading.appendChild(span);
        words.push(span);
      });
      heading.dataset.rqSplit = '1';
      return words;
    }

    /* First-level blocks of a section; lists and grids give their children so cards arrive one after another. */
    function blocksOf(section, heading) {
      var root = section.querySelector('.rq-wrap') || section.querySelector('[class*="__inner"]') || section;
      var items = [];
      Array.prototype.forEach.call(root.children, function (child) {
        if (/^(STYLE|SCRIPT|TEMPLATE)$/.test(child.tagName)) return;
        if (heading && (child === heading || child.contains(heading))) return;
        var isGroup = child.matches('ul, ol, [class*="__grid"], [class*="__list"]');
        if (isGroup && child.children.length > 1) {
          Array.prototype.forEach.call(child.children, function (c) { items.push(c); });
        } else {
          items.push(child);
        }
      });
      return items.filter(belowScreen);
    }

    function run() {
      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return;
      gsap.registerPlugin(ScrollTrigger);

      /* This theme scrolls inside .page-wrapper rather than the window on desktop. */
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 && getComputedStyle(wrapper).overflowY !== 'visible') {
        ScrollTrigger.defaults({ scroller: wrapper });
      }

      var sections = Array.prototype.filter.call(document.querySelectorAll('section'), function (s) {
        return isRqSection(s) && !s.classList.contains('rq-hero') && belowScreen(s);
      });

      var blocks = [];
      sections.forEach(function (section) {
        var heading = section.querySelector('h2');
        var words = heading && belowScreen(heading) ? splitWords(heading) : [];
        if (words.length) {
          gsap.set(words, { autoAlpha: 0, yPercent: 60 });
          gsap.to(words, {
            autoAlpha: 1,
            yPercent: 0,
            duration: 0.75,
            ease: 'power3.out',
            stagger: 0.045,
            clearProps: 'transform,opacity,visibility',
            scrollTrigger: { trigger: heading, start: 'top 90%', once: true }
          });
        }
        blocks = blocks.concat(blocksOf(section, words.length ? heading : null));
      });

      if (!blocks.length) return;
      gsap.set(blocks, { autoAlpha: 0, y: 28 });
      ScrollTrigger.batch(blocks, {
        start: 'top 92%',
        once: true,
        onEnter: function (batch) {
          gsap.to(batch, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: 'power3.out',
            stagger: 0.08,
            overwrite: true,
            clearProps: 'transform,opacity,visibility'
          });
        }
      });
      ScrollTrigger.refresh();
    }

    function start() {
      load(CDN + 'gsap.min.js')
        .then(function () { return load(CDN + 'ScrollTrigger.min.js'); })
        .then(run)
        .catch(function () { /* Network or CDN failure: the page stays static and fully visible. */ });
    }

    function whenIdle() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2500 });
      else window.setTimeout(start, 1200);
    }

    if (document.readyState === 'complete') whenIdle();
    else window.addEventListener('load', whenIdle, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
